import { PathUrlEnum, EventEnum, typeOfEventEnum } from './../../../utils/analytics.utils';
import { ItauDigitalAnalyticsView } from '@app-analytics/analytics';
import { Injectable } from '@angular/core';

/**
 * Serviço responsável por gerenciar a integração com o SDK Analytics Web do Itaú.
 *
 * @remarks
 * Para mais informações consulte a documentação oficial do SDK Analytics Web no github-pages do Itaú.
 *
 * @public
 */
@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private readonly implementationTeam = '19-triagem:contratacao';
  private readonly business = 'pf';
  private readonly environment = 'nao-logado';
  private readonly businessChannel = 'imobweb';

  /**
   * Construtor da classe AnalyticsService.
   *
   * @param itauDigitalAnalyticsView - Instância do ItauDigitalAnalyticsView.
   */
  constructor(private itauDigitalAnalyticsView: ItauDigitalAnalyticsView) {
    this.setDefaultUserProperties();
  }

  /**
   * Define as propriedades padrão do usuário.
   */
  setDefaultUserProperties(): void {
    let default_parameters = {
      analytics: {
        parameters: {
          business: this.business,
          environment: this.environment,
          business_channel: this.businessChannel,
        },
      },
    };

    this.itauDigitalAnalyticsView.setDefaultParameters(default_parameters);
  }

  /**
   * Registra um evento de screen_view de forma simplificada com parametros
   * recebidos separadamente no SDK Analytics Web do Itaú.
   *
   * @param eventName - Nome do evento.
   * @param customPath - Caminho personalizado do evento.
   * @param description - Descrição do evento. (opcional)
   * @param detail - Detalhes do evento.(opcional)
   */
  track(
    customPath: PathUrlEnum
  ): void {
    const event = {
      analytics: {
        event_name: typeOfEventEnum.screen_view,
        parameters: {
          custom_path: customPath,
          implementation_team: this.implementationTeam
        },
      },
    };

    this.itauDigitalAnalyticsView?.track(event);
    console.log('trackAnalyticsGA :: event :: screen_view :: ', event);
  }

  /**
   * Registra um evento no SDK Analytics Web do Itaú.
   *
   * @param event - Evento a ser registrado recebido por um objeto tipado.
   */
  trackEvent(
    customPath: PathUrlEnum,
    detail: EventEnum
  ): void {
    const event = {
      analytics: {
        event_name: typeOfEventEnum.click,
        parameters: {
          custom_path: customPath,
          implementation_team: this.implementationTeam,
          detail: detail
        },
      },
    };

    this.itauDigitalAnalyticsView.track(event);
    console.log('trackAnalyticsGA :: event :: click :: ', event);
  }
}
